import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import JoinByInviteContainer from './JoinByInviteContainer';
import { ROUTES } from '../../constants/routes';
import JoinByInviteLayout from './JoinByInviteLayout';
import GenericJoinPageV2 from './GenericJoinPageV2';
var MAX_WIDTH_PX = 432;
var JoinByInviteRoutes = function () {
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: ROUTES.GENERIC_JOIN_PAGE_V2, component: GenericJoinPageV2 }),
        React.createElement(Route, { path: ROUTES.JOIN_BY_INVITE, render: function () { return (React.createElement(JoinByInviteLayout, { contentMaxWidthPx: MAX_WIDTH_PX },
                React.createElement(JoinByInviteContainer, null))); } })));
};
export default JoinByInviteRoutes;
